<template>
  <div class="qblw-box">
    <div class="qblw-box-container">
      <div class="qblw-box-top">
        <span>{{$t('all.quanbuliwu')}}</span>
        <!-- 关闭按钮的点击事件，用于关闭整个弹窗 -->
        <img src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="handleClose" />
      </div>

      <!-- 礼物分类列表 -->
      <div class="qblw-box-fl">
        <div
          :class="index === listIndex ? 'qblw-box-fl-item' : 'qblw-box-fl-item1'"
          v-for="(item, index) in categoryList"
          :key="index"
          @click="handleChooseCategory(index)"
        >
          {{ item.categoryName }}
        </div>
      </div>

      <!-- 当前分类下的礼物列表 -->
      <div class="qblw-box-list" @mouseleave="handleListMouseLeave">
        <div
          :class="currentGiftIndex === index ? 'qblw-box-list-item' : 'qblw-box-list-item1'"
          v-for="(item, index) in currentGiftList"
          :key="index"
          @mouseenter="handleGiftMouseEnter(index, $event)"
        >
          <img class="qblw-box-list-item-img" :src="item.imgUrl" alt="" />
          <div class="qblw-box-list-item-span" v-if="currentGiftIndex !== index">{{ item.giftName }}</div>
          <span class="qblw-box-list-item-span1">{{ item.price }}US{{$t('all.bi')}}</span>
          <!-- 只有在鼠标悬停时才显示“赠送”按钮 -->
          <div
            v-if="currentGiftIndex === index"
            class="qblw-box-list-item-zs"
            @click.stop="giveGift()"
          >
            {{$t('all.zengsong')}}
          </div>
        </div>
      </div>
    </div>

    <!-- 数量选择弹窗 (从 liwu.vue 中引入) -->
    <popup
      v-if="showPopup"
      :show="showPopup"
      :x="popupPosition.x"
      :y="popupPosition.y"
      @mouseenter="handlePopupMouseEnter"
      @mouseleave="handlePopupMouseLeave"
      @giveGif="handleGiveGif"
    />
  </div>
</template>

<script>
import { getGiftList, giveGift } from "@/api/zhibo";
import { getPresentUserInfo } from '@/api/user';
// 假设你的 popup 组件路径是这个
import popup from "../popup/popup.vue"; 

export default {
  name: 'quanbuliwu',
  components: {
    popup
  },
  data() {
    return {
      // 原始的分类数据
      categoryList: [],
      // 当前选中的分类索引
      listIndex: 0,
      // 当前分类下的礼物列表
      currentGiftList: [],
      // 当前鼠标悬停的礼物索引
      currentGiftIndex: -1,

      // --- 从 liwu.vue 继承的状态 ---
      virtualBalance: 0,
      showPopup: false,
      popupPosition: { x: 0, y: 0 },
      hidePopupTimeoutId: null,
    };
  },
  mounted() {
    this.getGiftList();
    this.getPresentUserInfo();
  },
  beforeDestroy() {
    // 组件销毁前，确保清除所有未执行的定时器
    if (this.hidePopupTimeoutId) {
      clearTimeout(this.hidePopupTimeoutId);
    }
  },
  methods: {
    // --- 核心功能方法 ---

    // 获取礼物列表
    async getGiftList() {
      const res = await getGiftList({ liveId: this.$route.query.liveId });
      this.categoryList = res.data;
      // 默认显示第一个分类的礼物
	  this.currentGiftList = res.data[0].giftList
    },

    // 获取用户信息
    async getPresentUserInfo() {
      const res = await getPresentUserInfo();
      this.virtualBalance = res.data.virtualBalance;
    },

    // 选择礼物分类
    handleChooseCategory(index) {
      if (this.listIndex === index) {
        return;
      }
      this.listIndex = index;
      // 更新当前显示的礼物列表
      this.currentGiftList = this.categoryList[index].giftList;
      // 切换分类后，重置悬停状态
      this.currentGiftIndex = -1;
      // 切换分类后，确保弹窗关闭
      this.hidePopupImmediately();
    },
	//赠送礼物
	async giveGift() {
	  const params = {
	    liveId: this.$route.query.liveId,
	    giftId: this.currentGiftList[this.currentGiftIndex].giftId,
	    num: 1
	  };
	  const res = await giveGift(params);
	  // 赠送成功后立即隐藏弹窗，不需要延迟
	  this.hidePopupImmediately();
	  this.$emit('updateUser')
	},
	//选择礼物多个数量赠送
	async handleGiveGif(data){
		const params = {
		  liveId: this.$route.query.liveId,
		  giftId: this.currentGiftList[this.currentGiftIndex].giftId,
		  num: data
		};
		const res = await giveGift(params);
		console.log('送了礼物')
		this.$emit('updateUser')
		// 赠送成功后立即隐藏弹窗，不需要延迟
		this.hidePopupImmediately();
		
	},

    // 鼠标进入礼物项
    handleGiftMouseEnter(index, event) {
      // 如果已经是当前悬停项，不做处理
      if (this.currentGiftIndex === index) {
        return;
      }
      this.currentGiftIndex = index;
      // 显示数量选择弹窗
      this.showGiftPopup(event);
    },
    
    // 点击“赠送”按钮
    handleGiveGiftClick(item) {
      // 阻止事件冒泡，防止触发其他父级元素的 mouseleave 事件
      // 在模板中已使用 @click.stop
      console.log("准备赠送礼物:", item);
      // 点击按钮时，弹窗逻辑已经由 mouseenter 触发，这里可以留空或做其他事
    },

    // --- 弹窗控制逻辑 (完全复用 liwu.vue) ---

    showGiftPopup(event) {
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }

      const targetImage = event.currentTarget.querySelector('.qblw-box-list-item-img');
      if (!targetImage) return;

      const rect = targetImage.getBoundingClientRect();
      const POPUP_WIDTH = 352; // 弹窗宽度，需与 popup.vue 中一致
      
      let popupX = rect.left + rect.width / 2;
      const popupY = rect.top ;

      const popupLeftEdge = popupX - POPUP_WIDTH / 2;
      const popupRightEdge = popupX + POPUP_WIDTH / 2;

      if (popupLeftEdge < 0) {
        popupX = POPUP_WIDTH / 2;
      } else if (popupRightEdge > window.innerWidth) {
        popupX = window.innerWidth - POPUP_WIDTH / 2;
      }
      
      this.popupPosition = { x: popupX, y: popupY };
      this.showPopup = true;
    },

    handleListMouseLeave() {
      this.hidePopupTimeoutId = setTimeout(() => {
        this.hidePopupImmediately();
        this.hidePopupTimeoutId = null;
      }, 100);
    },

    handlePopupMouseEnter() {
      if (this.hidePopupTimeoutId) {
        clearTimeout(this.hidePopupTimeoutId);
        this.hidePopupTimeoutId = null;
      }
    },

    handlePopupMouseLeave() {
      this.hidePopupImmediately();
    },

    hidePopupImmediately() {
      this.showPopup = false;
      // 隐藏弹窗时，也重置礼物的悬停状态
      this.currentGiftIndex = -1;
    },
    
    // --- 赠送逻辑 (完全复用 liwu.vue) ---

    async handleGiveGif(data) {
      if (this.currentGiftIndex === -1) return;
      
      const currentGift = this.currentGiftList[this.currentGiftIndex];
      const params = {
        liveId: this.$route.query.liveId,
        giftId: currentGift.giftId,
        num: data
      };
      
      try {
		this.$emit('updateUser')
        await giveGift(params);
        this.getPresentUserInfo(); // 赠送成功后刷新余额
      } catch (error) {
        console.error("赠送礼物失败:", error);
        // 可以在这里给用户一些错误提示
      } finally {
        this.hidePopupImmediately();
      }
    },

    // 关闭整个组件的方法（如果需要）
    handleClose() {
        // 这里可以触发一个事件通知父组件关闭自己
        this.$emit('close');
    }
  },
  watch: {
    // 当切换分类时，自动将弹窗的位置计算逻辑应用到新分类的第一个礼物上
    listIndex(newVal) {
      if (newVal !== null && this.currentGiftList.length > 0) {
        // 这里可以优化，比如在渲染完成后找到第一个礼物的元素并计算位置
        // 为了简化，我们先让用户鼠标再次进入时才显示
      }
    }
  }
};
</script>

<style scoped lang="scss">
	/* 保留你原来的 qblw-box 的样式 */
	@import "./quanbuliwu.css"; 
</style>


// WEBPACK FOOTER //
// quanbuliwu.vue?f573420c